import AxiosInstanceCreator from 'services/api';

export const fcmInstance = new AxiosInstanceCreator().create();
